// import global variables.
import {headerHeight} from '../utils/global';

/**
 * スクロール検知
 *
 * @param  {HTMLElement} root         ルートとなる要素
 * @param  {HTMLElement} followTarget 追従させる要素
 * @param  {Object} options      interSectionObserberのオプション
 * @param  {Object} functions    可視領域に入り込む・出るタイミングで実行する処理
 * @return {Void}
 */
const followIfBleed = (root, followTarget, options, functions) => {
    const config = {
        className: {
            follow: 'is-follow'
        },
        observeDefaultOptions: {
            root: null,
            rootMargin: '0px',
            threshold: 0
        },
        functions: {
            interSectioningFunction: null,
            extraSectioningFunction: null
        }
    };
    const observeOptions = Object.assign(config.observeDefaultOptions, options);
    const functionOptions = Object.assign(config.functions, functions);
    const target = followTarget || root;
    let observer = null;

    const method = {
        /**
         * init - 初期化
         * @return {Void}
         */
        init() {
            if (!root) {
                return;
            }

            // オブザーバーを定義
            observer = new IntersectionObserver(method.interSection, observeOptions);
            observer.observe(root);
        },

        /**
         * interSection - 可視領域に入り込む・出る時に実行する処理
         * @param  {[type]} entries [description]
         * @return {[type]}         [description]
         */
        interSection(entries) {
            if (!entries) {
                return;
            }

            entries.forEach((entry) => {
                // 入り込んだ場合
                if (entry.isIntersecting) {
                    target.classList.remove(config.className.follow);

                    // 処理が指定されていたら実行する
                    if (typeof functionOptions.interSectioningFunction === 'function') {
                        functionOptions.interSectioningFunction(observer, target);
                    }

                // 出た場合
                } else {
                    target.classList.add(config.className.follow);

                    // 処理が指定されていたら実行する
                    if (typeof functionOptions.extraSectioningFunction === 'function') {
                        functionOptions.extraSectioningFunction(observer, target);
                    }
                }
            });
        }
    };

    // 初期化を実行
    method.init();
};

/**
 * デフォルト実行処理
 * @return {Void}
 */
export default () => {
    const header = document.querySelector('.l-header');
    const footer = document.querySelector('.l-footer');
    const toTopLink = footer.querySelector('.l-footer-pageTop');

    // 追従ヘッダー
    followIfBleed(header, null, {
        rootMargin: `-${headerHeight}px 0px`
    });

    // ページトップリンク追従
    followIfBleed(header, toTopLink);

    const mv = document.querySelector('.p-mainVisual');

    // MVがない場合はコンバージョンリンクは存在しないので追従は実装しない
    if (mv !== null) {
        // フッターコンバージョンリンク追従
        followIfBleed(mv, footer.querySelector('.l-footer__conversion'), {
            rootMargin: `-${headerHeight}px 0px`
        }, {
            interSectioningFunction() {
                footer.setAttribute('data-conversion-follow', 'false');
            },
            extraSectioningFunction() {
                footer.setAttribute('data-conversion-follow', 'true');
            }
        });
    }

    const twitterWidget = document.querySelector('.twitter-wjs');

    // Twitter TimeLine
    if (twitterWidget !== null) {
        followIfBleed(twitterWidget, null, {
            rootMargin: '100px 0px'
        }, {
            interSectioningFunction(observer, target) {
                const script = document.createElement('script');

                script.src = 'https://platform.twitter.com/widgets.js';
                script.async = true;
                document.head.appendChild(script);

                observer.unobserve(target);
            }
        });
    }

    const youtubeWidget = document.querySelector('.g-ytsubscribe');

    // YouTube Subscribe
    if (youtubeWidget !== null) {
        followIfBleed(youtubeWidget, null, {
            rootMargin: '100px 0px'
        }, {
            interSectioningFunction(observer, target) {
                const script = document.createElement('script');

                script.src = 'https://apis.google.com/js/platform.js';
                script.async = true;
                document.head.appendChild(script);

                observer.unobserve(target);
            }
        });
    }
};
